import {
  type TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { formatTimestamp } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";
import { Cell } from "./cell";
import { CellFundSources } from "./cell-fundsources";

type RefundTransactionDetailProps = {
  transactionGroup: TransactionGroup;
};

export function RefundTransactionDetail({
  transactionGroup,
}: RefundTransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const store = summaryDetail.store;

  if (!store) {
    return null;
  }

  const refundDetail = transactionGroup.transactionDetails.find(
    (d) => d.transaction?.type === Transaction_Type.REFUND,
  );

  const paymentDetail = transactionGroup.transactionDetails.find(
    (d) => d.transaction?.type === Transaction_Type.PAYMENT,
  );

  if (!refundDetail) {
    return null;
  }

  // 複数ポイントのrefundを考慮して、返金済みのポイントを集計する
  const refundAmount = transactionGroup.transactionDetails
    .filter((d) => d.transaction?.type === Transaction_Type.REFUND)
    .reduce((acc: number, ts) => acc + Number(ts.transaction?.amount || 0), 0);

  return (
    <div
      className={css({
        bg: "white",
        px: "16px",
        rounded: "16px",
      })}
    >
      <Cell label={t("取引種別")} value={t("お支払い（返金済み）")} />
      <Cell
        label={t("支払いポイント")}
        value={`${formatNumber(refundAmount)}pt${t("（返金済み）")}`}
        styles={{
          borderBottom: "none",
        }}
      />
      <CellFundSources transactionGroup={transactionGroup} />
      <Cell label={t("店舗名")} value={store.name} />
      {paymentDetail && (
        <Cell
          label={t("支払い日時")}
          value={formatTimestamp(paymentDetail.transaction?.createdAt)}
        />
      )}
      <Cell
        label={t("返金日時")}
        value={formatTimestamp(refundDetail.transaction?.createdAt)}
      />
      <Cell label={t("取引ID")} value={transactionGroup.id} lastChild={true} />
    </div>
  );
}
